/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyProductCategorySummary extends models.CostAnomalySummary {
    getFixupPrototypeFunction() { return CostAnomalyProductCategorySummary.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyProductCategorySummary>): CostAnomalyProductCategorySummary {
        let obj = Object.assign(new CostAnomalyProductCategorySummary(), model);
        CostAnomalyProductCategorySummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyProductCategorySummary>): CostAnomalyProductCategorySummary {
        if (!model) return null;
        return CostAnomalyProductCategorySummary.newInstance(<CostAnomalyProductCategorySummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyProductCategorySummary) {
        if (!obj) return;

        models.CostAnomalyProductCategorySummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyProductCategorySummary): boolean {
        if (models.CostAnomalySummary.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalyProductCategorySummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Name of the Product category
     */
    product_category: string;

    /**
     * Name of the Resource category
     */
    resource_category: string;

}
